import {HttpClient} from "@angular/common/http";
import {KeycloakMatchingDTO} from "./models/keycloak-matching.dto";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {AbstractService} from "../../../services/AbstractService";
import {OrganisationDTO} from "../../../DTO/Organisation/OrganisationDTO";
import {environment} from "../../../../environments/environment";
import {tap} from "rxjs/operators";
import { RoleDTO } from './models/role.dto';
import { RoleMappingDTO } from './models/role-mapping.dto';
import {KeycloakUserEntity} from "./models/keycloak-user-entity";
import {PageableRequest} from "../../../../core/PageableRequest";
import {PageableResponse} from "../../../../core/PageableResponse";

@Injectable({
  providedIn: 'root'
})
export class KeycloakService extends AbstractService<OrganisationDTO>{

  protected constructor(protected override http: HttpClient) {
    super(http);
  }
  override getApiURL() {
    return "keycloak-matching";
  }
  save(data: KeycloakMatchingDTO): Observable<any> {
    return this.http.post(`${environment.apiUrl}${this.getApiURL()}/save`, data);
  }

  getAllRoles(): Observable<RoleDTO[]> {
    return this.http.get<RoleDTO[]>(`${environment.apiUrl}${this.getApiURL()}/all-roles`);
  }


  saveRoleMappings(mappings: RoleMappingDTO[], subdomain: string): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}${this.getApiURL()}/save-mappings`,
      mappings,
      {
        params: { subdomain }
      }
    );
  }

  getKeycloakMatchingByOrganizationId(organizationId: number): Observable<KeycloakMatchingDTO> {
    return this.http.get<KeycloakMatchingDTO>(`${environment.apiUrl}${this.getApiURL()}/by-organization/${organizationId}`);
  }

  getUsersByOrganizationId(request: PageableRequest): Observable<PageableResponse> {
    return this.http.post<PageableResponse>(`${environment.apiUrl}${this.getApiURL()}/user-by-organization/`,request.getRequestBody());
  }

  importUsers(userList: KeycloakUserEntity[]): Observable<KeycloakUserEntity[]> {
    return this.http.post<KeycloakUserEntity[]>(`${environment.apiUrl}${this.getApiURL()}/import-user/`,userList);
  }

}
